<vectronic-filter-header
  (titleClicked)="toggleFilter()"
  [title]="title()"
  (enabledFilterToggle)="toggleFilter()"
  [isFilterEnabled]="!isFilterHidden()"
></vectronic-filter-header>
<div class="filter-body" [hidden]="isFilterHidden()">
  <div class="container">
    <mat-form-field appearance="outline" class="filter-field">
      @if (!hideLabel()) {
        <mat-label>{{ title() }}</mat-label>
      }
      <mat-select [(ngModel)]="selectedItem">
        @for (item of availableFilterItems(); track item) {
          <mat-option [value]="item.item">{{ item.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
